import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {message} from 'antd';
import {AxiosError, AxiosResponse} from 'axios';
import authService from './authServices';
import {LOGIN_PAYLOAD, USER} from './auth.type';

const initialState = {
  isLoading: false,
  user: {
    details: {
      email: '',
      id: null,
      name: '',
      organisationId: '',
      username: '',
      phone: '',
    },
    token: null,
  } as USER,
};

export const login = createAsyncThunk(
  'auth/login',
  async ({username, password}: LOGIN_PAYLOAD, thunkAPI) => {
    try {
      const data: AxiosResponse = await authService.login({username, password});
      return data;
    } catch (error) {
      const result = error as AxiosError;

      return thunkAPI.rejectWithValue(result.message);
    }
  },
);
export const logout = createAsyncThunk('auth/logout', async () => {
  await authService.logout();
});

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // clearError(state) {
    //   state.error = null;
    // },
  },

  extraReducers: (builder) => {
    builder.addCase(login.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      state.isLoading = false;

      state.user = action.payload.data;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.isLoading = false;
      state.user = initialState.user;
      message.error(`${action.payload}`);
    });
    builder.addCase(logout.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(logout.fulfilled, (state) => {
      state.isLoading = false;
      state.user = initialState.user;
    });
  },
});

//export const {clearError} = authSlice.actions;
export default authSlice.reducer;
